/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import FinanceForm from 'domain/people/employee/finance/createupdate/FinanceForm';
import useFinanceService, { FINANCE_TYPES_ALIASES } from 'domain/people/employee/finance/shared/financeService';
import { useFinanceUrl } from 'domain/people/employee/finance/financeRouting';
import { CURRENCY_TYPES } from 'domain/shared/core/constants';
import { BASE_AMOUNT_TYPES_ALIASES } from 'domain/shared/employee';

const CreateFinancePage = () => {
  const { create, getValidationSchema } = useFinanceService();
  const { getListUrl } = useFinanceUrl();

  return (
    <CreateForm
      submitFormFunc={create}
      initialData={{
        type: FINANCE_TYPES_ALIASES.PRIMARY,
        baseAmountType: BASE_AMOUNT_TYPES_ALIASES.MONTHLY,
        currency: CURRENCY_TYPES.USD,
      }}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Compensation package has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Compensation package" titleVariant="h4">
        <FinanceForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateFinancePage;
